import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c2ab0c6c&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=c2ab0c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ab0c6c",
  null
  
)

export default component.exports